<template>
  <el-row
    v-if="type === 'checkbox-outer'"
  >
    <el-col :xs="24">
      <el-checkbox
        v-model="val"
        @change="change"
        :disabled="disabled"
      >
        {{ labelText }}
        <el-popover
          v-if="hasDesc"
          placement="top"
          :title="labelText"
          trigger="hover"
          transition="none"
          :open-delay="100"
          :tabindex="-1"
        >
          <div
            class="form-item-readme-content"
            v-html="desc"
          >
          </div>
          <el-link
            slot="reference"
            class="checkbox-outer-link"
            icon="el-icon-question"
            :underline="false"
            type="warning"
          >
          </el-link>
        </el-popover>
      </el-checkbox>
    </el-col>
    <el-col
      :xs="24"
      v-if="val"
    >
      <el-card
        class="bos-card"
      >
        <slot></slot>
      </el-card>
    </el-col>
  </el-row>
  <form-item
    v-else
    v-bind="$attrs"
    :name="name"
    :label="label"
    :hasLabel="hasLabel"
    :descContent="desc"
    class="form-card"
  >
    <el-card
      v-if="type === 'checkbox'"
      :class="cardClass"
    >
      <div slot="header">
        <el-checkbox
          v-model="val"
          @change="change"
        >
          {{ labelText }}
        </el-checkbox>
      </div>
      <div v-show="val">
        <slot></slot>
      </div>
    </el-card>
    <el-card
      v-else
      class="box-card"
    >
      <slot></slot>
    </el-card>
  </form-item>
</template>

<script>

import { getTransText } from '@/utils/i18n'

export default {
  name: 'form-card',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    labelText: {
      type: String,
      default: ''
    },
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    descContent: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      val: this.value
    }
  },
  computed: {
    cardClass () {
      return this.val ? 'box-card' : 'box-card hidden-card'
    },
    hasLabel () {
      if (this.hideLabel) {
        return false
      }

      switch (this.type) {
        case 'checkbox':
        case 'checkbox-outer':
          return false
      }
      return true
    },
    label () {
      if (this.labelText !== '') {
        return this.labelText
      }
      return this.getTransText(this.base + '.blocks.' + this.name, 'label')
    },
    desc () {
      if (this.descContent !== '') {
        return this.descContent
      }

      return this.getTransText(this.base + '.blocks.' + this.name, 'desc')
    }
  },
  methods: {
    getTransText,
    change () {
      this.$emit('input', this.val)
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    }
  }
}
</script>
